export enum ETab {
  Reviews = 'reviews',
  Questions = 'questions',
}
